// @flow
import { connect } from 'react-redux';
import { CommonActions } from '@react-navigation/native';
import { compose, withProps } from 'react-recompose';
import type { State } from '../../modules/reducers';
import { GenericLogin } from '../../components/common';
import config from '../../config';
import type { DispatchProps, StateProps } from '../../components/common/GenericLogin';
import { loginDuringActivate } from '../../modules/Authentication/actions';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';
import Navigation from '../../lib/navigation';

const mapStateToProps = (state: State): StateProps => ({
  isLoading: isLoadingSelector(state, 'loginDuringActivate'),
  disableCreateAccount: !config.canCreateAccountDuringActivate,
});

const mapDispatchToProps: DispatchProps = {
  onSubmit: loginDuringActivate,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps({
    goToCreateAccount: () => Navigation.dispatch(CommonActions.navigate({ name: 'createAccountDuringActivate' })),
  })
)(GenericLogin);
